/* projects/fitnessforservice/src/app/warning-modal/warning-modal.component.css */
.warning-icon {
  color: orange;
  transform: scale(2);
  margin: 15px;
}
.icon-container {
  height: 50px;
}
.dialog-container {
  display: flex;
}
.warning-text {
  margin: auto;
  color: black;
  list-style-type: none;
}
.dialog-actions {
  float: right;
}
.captionLeft {
  text-align: left;
  font-size: 30px;
  margin: 10px;
}
/*# sourceMappingURL=warning-modal.component-ME3ZHVMN.css.map */
